<template lang="pug">
.log-wrapper
  .logbox
    b-card.shadow-lg.rounded.theme-glass
      div.p-4
        div.d-flex.flex-row.align-items-baseline
          h4 {{ $t("ui.combine.reset_password") }}
        b-form.form-signin(@submit.stop.prevent="updatePassword" novalidate :disabled="!submission.success")
          b-input-group
            b-input-group-text(slot="prepend")
              i.fas.fa-lock
            DebounceInput(
              required
              ref="old_password"
              type="password"
              v-model.trim.lazy="$v.old_password.$model"
              :placeholder='$t("ui.combine.old_password")'
              :disabled="loading"
              :dirty="$v.old_password.$dirty"
              :error="$v.old_password.$error"
              )
          ValidateResult(:value="$v.old_password" :name="$t('ui.combine.old_password')")
          b-input-group
            b-input-group-text(slot="prepend")
              i.fas.fa-lock
            DebounceInput(
              required
              ref="new_password"
              type="password"
              v-model.trim.lazy="$v.new_password.$model"
              :placeholder='$t("ui.combine.new_password")'
              :disabled="loading"
              :dirty="$v.new_password.$dirty"
              :error="$v.new_password.$error"
              )
          ValidateResult(:value="$v.new_password" :name="$t('ui.combine.new_password')")
          b-input-group
            b-input-group-text(slot="prepend")
              i.fas.fa-lock
            DebounceInput(
              required
              type="password"
              v-model.trim.lazy="$v.confirm_password.$model"
              :placeholder='$t("ui.combine.confirm_password")'
              :disabled="loading"
              :dirty="$v.confirm_password.$dirty"
              :error="$v.confirm_password.$error"
            )
          ValidateResult(:value="$v.confirm_password" :name="$t('ui.combine.confirm_password')" :name2="$t('ui.combine.new_password')")
          div.row.pt-2
            div.col
              b-alert.text-center.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}  
          div.row
            .m-auto.w-70
              SubmitButton.btn-block.noboxshadow.br-8(icon="fas fa-redo" type="button" :text="$t('ui.reset')" variant="warning" size="xs" :loading="loading" isModal=false @click="clear()")
              SubmitButton.btn-block.noboxshadow.br-8(icon="fa fa-save" :text="$t('ui.save')" variant="success" size="xs" :loading="loading" isModal=false @click="updatePassword()")

</template>

<script>
import config from "@/config";
import { required, minLength, maxLength, sameAs, alphaNum, helpers } from "vuelidate/lib/validators";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

const containAlphaNum = helpers.regex("containAlphaNum", /^(?=.*\d)(?=.*[a-zA-Z])/);

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  data: function() {
    return {
      old_password: "",
      new_password: "",
      confirm_password: "",
      loading: false,
      submission: {
        success: true,
        status: ""
      },
      redirect: "/settings"
    };
  },
  validations: {
    old_password: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(50),
      containAlphaNum
    },
    new_password: {
      required,
      containAlphaNum,
      minLength: minLength(6),
      maxLength: maxLength(50)
    },
    confirm_password: {
      required,
      sameAs: sameAs("new_password")
    }
  },
  mounted: function() {
    this.$refs.old_password.$el.focus();
  },
  methods: {
    reset: function() {
      this.$v.$reset();
      this.submission.success = true;
      this.submission.status = "";
    },
    clear: function() {
      this.old_password = ""
      this.new_password = ""
      this.confirm_password = ""
      this.$nextTick(() => {
        this.reset()
      });
    },
    updatePassword: function() {
      this.reset();
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.loading = true
        let password = this.old_password
        let new_password = this.new_password
        this.$store
          .dispatch("user/updatePassword", { password, new_password })
          .then(response => {
            this.loading = false
            this.submission.success = response.success
            this.submission.status = response.status
            this.$swal({
              title: this.$t("ui.combine.update_password"),
              text: this.$t("message.successful_update_account_password"),
              type: "success",
              allowOutsideClick: false
            }).then(isConfirm => {
              if (isConfirm) {
                this.cancel();
              }
            });
          })
          .catch(response => {
            this.loading = false
            this.submission.success = response.success
            this.submission.status = this.$t("error." + response.status);
          });
        }
    },
    cancel: function() {
      this.clear()
      this.$router.push("/system/setting")
    }
  }
};
</script>
